import {all, call, put, select, takeEvery} from "redux-saga/effects";
import {ActionType, getType} from "typesafe-actions";
import {addBonus, addCoins} from "../player/actions";
import {BonusType} from "../player/types";
import revealTile from "./handlers/revealTile";
import revealMap from "./handlers/revealMap";
import showExit from "./handlers/showExit";
import doubleChance from "./handlers/doubleChance";
import fiftyFifty from "./handlers/fiftyFifty";
import majorityVote from "./handlers/majorityVote";
import skipQuestion from "./handlers/skipQuestion";
import {IApplicationState} from "../index";
import {applyHint} from "./actions";
import playSound from "../../shared/sounds/playSound";
import forkWithErrHandler from "../../shared/utils/forkWithErrHandler";

function* getHintWorker(hint: BonusType) {
    switch (hint) {
        case BonusType.RevealTile:
            return yield call(revealTile);

        case BonusType.RevealMap:
            return yield call(revealMap);

        case BonusType.ShowExit:
            return yield call(showExit);

        case BonusType.DoubleChance:
            return yield call(doubleChance);

        case BonusType.FiftyFifty:
            return yield call(fiftyFifty);

        case BonusType.MajorityVote:
            return yield call(majorityVote);

        case BonusType.SkipQuestion:
            return yield call(skipQuestion);
    }

    return false;
}

export function* handleApplyHint({payload: { id, hint }}: ActionType<typeof applyHint.request>) {
    const {availableCoins, hintCount, hintCost} = yield select(({ settings, player }: IApplicationState) => ({
        availableCoins: player.coins,
        hintCount: player.bonuses[hint],
        hintCost: settings.gameBalance.hintCost[hint],
    }));

    const isAvailable = hintCount > 0
        || availableCoins >= hintCost;

    if (isAvailable) {
        const success = yield call(getHintWorker, hint);
        if (success) {
            if (hintCount > 0) {
                yield put(addBonus({ bonus: hint, count: -1 }, "used_bonus_paid"));
            } else {
                yield put(addCoins(-hintCost, "purchased_bonus"));
            }

            yield put(applyHint.success({ id, hint }));

            playSound("bonus-use");
            return;
        }
    }

    yield put(applyHint.failure({ id, hint }));

    playSound("not-enough-coins", 0.5)
}

function* watchApplyHint() {
    yield takeEvery(getType(applyHint.request), handleApplyHint);
}

export default function* hintsSaga() {
    yield all([
        forkWithErrHandler("hintsSaga", "watchApplyHint", watchApplyHint),
    ]);
}